const LeftBorderHeading = ({ heading_class, heading_title }) => {
    return (
        <h3 className={`relative  flex items-center text-enthusia-primary font-semibold capitalize before:content-[""] before:absolute before:w-[6px] before:h-[50px] before:bg-enthusia-primary before:rounded-r-xl leading-[28px] md:leading-[34px] ${heading_class}`}><span className='inline-block pl-[18px]'>{heading_title}</span></h3>
    )
}

export default LeftBorderHeading;